import React, { useCallback } from 'react'
import ConfirmModal from '../../../organisms/confirm-modal/ConfirmModal'

import useAPIRequest from '../../../../hooks/useAPIRequest'
import API from '../../../../services/api'
import { formatPersonName } from '../../../../lib/formatters'

interface Props {
  isOpen: boolean
  onClose: () => void
  onComplete: () => void
  eventId: string
  participants: API.ParticipantResponse[]
}
const participantsToIds = (participants: API.ParticipantResponse[]) => {
  const ids = []
  for (const p of participants) {
    ids.push(p.id)
  }
  return ids
}

function DeleteParticipant({ isOpen, onClose, onComplete, participants, eventId }: Props) {
  const callback = useCallback(() => {
    return participants.length ? API.deleteParticipants(eventId, participantsToIds(participants)) : API.deleteAllParticipants(eventId)
  }, [eventId, participants])

  const [{ inProgress, error }, doAPIRequest] = useAPIRequest<{}>(callback, null)

  const handleConfirm = useCallback(() => {
    if (participants.length > 0) {
      doAPIRequest(onComplete)
    } else {
      onClose()
    }
  }, [doAPIRequest, onComplete, participants, onClose])

  let message = ''
  let noParticipants = false

  if (participants.length === 0) {
    message = 'No participants were selected. Please select a participant to delete'
    noParticipants = true
  } else if (participants.length === 1) {
    message = `Are you sure you want to delete ${formatPersonName(participants[0])}?`
  } else {
    message = `Are you sure you want to delete ${participants.length} participants?`
  }

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onCancel={noParticipants ? undefined : onClose}
      onConfirm={handleConfirm}
      confirmInProgress={inProgress}
      title={`${message}`}
      confirmTitle={noParticipants ? 'Ok' : 'Delete'}
      error={error && error.message}
      disabled={inProgress}
      warning={noParticipants ? false : true}
    />
  )
}

export default DeleteParticipant
